import TagCreate from './Create';
import TagEdit from './Edit';
import TagList from './List';

export const FAQTagCreate = (props) => <TagCreate backUrl="/faq/tags" {...props} />;
export const FAQTagEdit = (props) => <TagEdit backUrl="/faq/tags" {...props} />;
export const FAQTagList = (props) => (
    <TagList createUrl="/faq/tags/create" editUrl={(t) => `/faq/tags/edit/${t.id}`} backUrl="/faq" {...props} />
);
export { TagCreate, TagEdit, TagList };
